module.exports = __webpack_public_path__ + "img/settings.17bad64e.png";